<template>
  <!-- hs编码弹框用作选择查询 -->
  <el-dialog :visible.sync="hsCodeVisible" @close="close" :title="queryType == 1 ? $i18.language('选择行业') : $i18.language('选择HS编码')">
    <div class="hscode-data">
      <el-input size="mini" v-model="filterText" :placeholder="$t('productDetail.pleaseEnterkeyWord')" @keyup.enter.native="getHsCodeDatated">
        <i slot="suffix" class="el-input__icon el-icon-search" @click="getHsCodeDatated"></i>
      </el-input>
      <div v-loading="loadingTree" :class="[loadingTree ? 'loadingStyle' : '']">
        <div class="shotree" v-if="hsCodeData && hsCodeData.length > 0">
          <el-tree class="filter-tree" :data="hsCodeData" @check="checkTree" :default-checked-keys="defaultHsCodeKeys" :default-expanded-keys="defaultExpandedKeys" show-checkbox ref="tree" node-key="id" :filter-node-method="filterNode">
            <span class="custom-tree-node" slot-scope="{ node }">
              <span v-if="!filterText">{{ node.label }}</span>
              <span v-if="filterText" v-html="node.label.replace(new RegExp(filterText, 'g'), `<font>${filterText}</font>`)" />
            </span>
          </el-tree>
        </div>
      </div>
      <div class="btn-group">
        <el-button size="small" class="sub-confirm-btn" @click="close">{{ $t('cancel') }}</el-button>
        <el-button size="small" class="confirm-btn" @click="confirmHsCode">{{ $t('sure') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    fetchMethod: {
      type: Function,
      default: () => {},
    },
    codeCheckLength: {
      type: [Number, String],
      default: 5
    },
    // 限制个数
    submitCodeLimit: {
      type: Number,
      default: -1
    }
  },
  components: {},
  data() {
    return {
      hsCodeVisible: false,
      queryType: 0, // 判断是hscode还是行业
      hsCodeData: [],
      filterText: '',
      loadingTree: false, // 加载行业HS的loading
      defaultHsCodeKeys: [],
      selectParentItems: [], // 展示的所有选中的最高级节点树
      hsShowCodeLable: [], //节点对应的中文名称
      hsShowCodes: ['0'], // 选中的最高级节点id
      hsCodeParams: {
        countryId: 0,
        isEnLanguage: localStorage.getItem("language")=='en'?true:false,
        keyword: '',
      },
      contactHsCodes: [], //拼接处理过的数组
      defaultExpandedKeys: [], //展开所选中的节点
      idList: [], //获取第一大类下的最后的id
    }
  },

  mounted() {},
  created() {
    // this.getHsCodeData()
  },
  beforeDestroy() {
    this.$store.commit('store_IndustryData', [])
    this.$store.commit('store_hsCodeData', []) 
  },
  methods: {
    close() {
      this.hsCodeVisible = false
      this.hsCodeData = []
      this.defaultHsCodeKeys = []
      this.selectParentItems = [] // 展示的所有选中的最高级节点树
      this.hsShowCodes = ['0'] // 选中的最高级节点id
      this.hsCodeParams.countryId = 0
      this.hsCodeParams.keyword = ''
      this.defaultExpandedKeys = []
    },
    filterNode(value, hsCodeData) {
      if (!value) return true
      if(/^[0-9]*$/.test(value)) {
        return hsCodeData.label.indexOf(value) === 0
      } else {
        return hsCodeData.label.indexOf(value) !== -1
      }
    },
    getHsCodeDatated() {
      let val = this.filterText.trim()
      if(val&&val.length<2) {
        this.$message.warning(this.$i18.language('输入内容至少2位'))
        return
      }
      this.$refs.tree.filter(val)
    },
    open(data, num) {
      this.hsCodeVisible = true
      this.queryType = num
      this.$nextTick(() => {
        if (this.$refs.tree) {
          this.defaultHsCodeKeys = []
          if (num == 0) {
            //hs编码
            if (data.length == 0) {
              this.defaultExpandedKeys = this.FilterChildren(this.hsCodeData) //默认展开第一个节点
            } else {
              this.defaultExpandedKeys = data
            }
          } else {
            this.defaultExpandedKeys = data
          }
          this.$refs.tree.setCheckedKeys(data)
          this.selectParentItems = this.getSimpleCheckedNodes(this.$refs.tree.store, []);
        } else {
          this.defaultHsCodeKeys = [0]
        }
      })
    },
    getHsCodeData(num) {
      //  this.open(data)
      //解决数据加载慢，导致树形结构无法回显，将数据存储在vuex
      let getData = num == 1 ? this.$store.getters.industryData : this.$store.getters.hsCodeData
      //判断vuex里面是否存在数据
      if (getData && getData.length > 0) {
        this.hsCodeData = []
        this.hsCodeData = getData
      } else {
        this.loadingTree = true
        // this.$api.public[interfaceName]
        let fetchMethod = num && num == 1 ? this.$api.public.getCompanyIndustryCateGory : this.$api.public.getHsCodeData
        fetchMethod(this.hsCodeParams).then((res) => {
          this.hsCodeData = this.isDisabled(res.data)
          num && num == 1 ? this.$store.commit('store_IndustryData', this.hsCodeData) : this.$store.commit('store_hsCodeData', this.hsCodeData) //存放hscode编码
          this.loadingTree = false
        })
      }
    },
    FilterChildren(hsCodeData) {
      let firstNode = hsCodeData[0]
      if (firstNode.children && firstNode.children.length > 0) {
        firstNode.children.forEach((item, index) => {
          if (index == 0) {
            if (item.children && item.children.length > 0) {
              this.FilterChildren(item.children)
            } else {
              this.idList = []
              this.idList.push(item.id)
            }
          }
        })
      }
      return this.idList
    },
    //是否禁用（小于八位禁用）
    isDisabled(data) {
      data.forEach((item) => {
        let judge = item.id.length < 1*this.codeCheckLength
        if(1*this.codeCheckLength>1) {
          judge = (!(1*item.id) || item.id.length < 1*this.codeCheckLength)
        }
        if (judge) {
          item.disabled = true
          if (item.children && item.children.length) {
            this.isDisabled(item.children)
          }
        }
      })
      return data
    },
    getSimpleCheckedNodes(store, thisNode) {
      const checkedNodes = []
      const traverse = function(node, thisNode) {
        const childNodes = node.root ? node.root.childNodes : node.childNodes
        childNodes.forEach(child => {
          if (child.checked) {
            checkedNodes.push(child.data)
          }
          if (child.indeterminate) {
            traverse(child, thisNode)
          }
        })
      }
      traverse(store, thisNode)
      return checkedNodes
    },
    // 选中树形节点
    checkTree(data) {
      let thisNode = this.$refs.tree.getNode(data.id)
      this.selectParentItems = this.getSimpleCheckedNodes(this.$refs.tree.store, thisNode);
    },
     // 选中节点去重
    unique(nodes) {
      let res = [],
      obj = {}
      for (let i = 0; i < nodes.length; i++) {
        if (!obj[nodes[i].data.id]) {
          res.push(nodes[i])
          obj[nodes[i].data.id] = 1
        } else {
          obj[nodes[i].data.id]++
        }
      }
      return res
    },
    // 递归将选中的当前对象变为一维数组，获取所有子元素id
    flatten(arr) {
      return [].concat(
        ...arr.map((item) => {
          if (item.childNodes) {
            let arr = [].concat(item, ...this.flatten(item.childNodes))
            return arr
          }
          return [].concat(item)
        })
      )
    },
    // 选中Hs
    confirmHsCode() {
      let hsShowCodes = this.selectParentItems.map((item) => item.id)
      this.hsShowCodes = Array.from(new Set(hsShowCodes))
      let hsShowCodeLable = this.selectParentItems.map((item) => item.label) //获取节点对应的中文名称
      this.hsShowCodeLable = Array.from(new Set(hsShowCodeLable))
      const hsCodes = this.$refs.tree.getCheckedNodes().map((item) => {
        return item.id
      })
      //将选中的节点拼接成[{label:'',id:0}]
      if (this.hsShowCodes.length == this.hsShowCodeLable.length) {
        this.contactHsCodes = this.changeContactHscodes()
      }
      if(this.submitCodeLimit>-1&&this.contactHsCodes.length>this.submitCodeLimit){
        let message = `${this.$i18.language('HS编码仅支持选择')}${this.submitCodeLimit}${this.$i18.language('个')}`
        this.$message.warning(message)
        return
      }
      if (!this.hsShowCodes.length) {
        this.hsShowCodes = [] 
        // this.chart1Params.hsCode = []
      }
      // this.hsShowCodes用于展示的hscode。
      // hsCodes用于传给后端查询的hscode
      this.$emit('confirmHsCode', hsCodes, this.hsShowCodes, this.hsShowCodeLable, this.contactHsCodes, this.selectParentItems)
      this.close()
    },
    changeContactHscodes() {
      let contactHsCodes = []
      this.hsShowCodes.forEach((item, index) => {
        contactHsCodes.push({
          val: item,
          label: this.hsShowCodeLable[index],
        })
      })
      return contactHsCodes
    },
  },
}
</script>

<style lang="scss" scoped>
.hscode-data {
  .shotree {
    height: 50vh;
    overflow: auto;
    margin-top: 10px;
  }

  /deep/.filter-tree {
    .el-tree-node {
      .el-tree-node__content {
        height: auto;

        .el-tree-node__label {
          white-space: normal;
          padding: 5px 0;
          line-height: 18px;
          word-break: break-word;
        }
      }
    }
  }

  .btn-group {
    padding-top: 20px;
    text-align: right;
  }
}
.loadingStyle {
  width: 100%;
  height: 300px;
}
</style>
